import { map } from 'lodash-es';
import numberMixin from '../../../../mixins/numberMixin';
import statusEnums from '../../../../variables/ski/school/status-type-enums';
import lessonTypeEnums from '../../../../variables/ski/school/lesson-type-enums';

export default {

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*}
   */
  getSkiSchools(state, getters, rootState, rootGetters) {
    const stateSchools = state.schools.items;
    const stateMeetingPoints = state.meetingPoints.items;
    const stateParticipants = rootGetters['booking/getParticipantsWithFullName'];
    const stateBookingStaysWithArea = rootGetters['booking/getBookingStaysWithArea'];

    if (!stateParticipants
      || !stateParticipants.length
      || !stateSchools
      || !stateSchools.length
      || !stateBookingStaysWithArea
      || !stateBookingStaysWithArea.length
    ) {
      return [];
    }

    const selectedBookingParticipantId = state.search.selectedBookingParticipantId;
    const selectedAreaId = state.search.selectedAreaId;

    const schools = stateSchools.filter(school =>
      school.skiSchoolParticipants.filter(skiSchoolParticipant =>
        skiSchoolParticipant.bookingParticipantId === selectedBookingParticipantId
        || !selectedBookingParticipantId),
    ).map((school) => {
      const area = rootState.booking.areas.items.find(a => a.id === school.areaId);
      const meetingPoints = stateMeetingPoints.filter(
        stateMeetingPoint => stateMeetingPoint.twentyAreaId === area.id,
      );
      const skiSchoolParticipantIds = school.skiSchoolParticipants.map(
        participant => participant.bookingParticipantId,
      );
      const availableParticipants = stateParticipants.filter(stateParticipant =>
        !skiSchoolParticipantIds.includes(stateParticipant.id),
      );
      const participants = [];
      school.skiSchoolParticipants.forEach((skiSchoolParticipant) => {
        const participant = stateParticipants.find(stateParticipant =>
          stateParticipant.id === skiSchoolParticipant.bookingParticipantId,
        );
        participants.push(participant);
      });

      let statusColor;
      let statusIcon;
      switch (school.status) {
        case statusEnums.PAID:
          statusColor = 'green';
          statusIcon = 'check_circle';
          break;
        case statusEnums.CANCELLED:
        case statusEnums.STOPPED:
          statusColor = 'red';
          statusIcon = 'warning';
          break;
        default:
          statusColor = 'orange';
          statusIcon = 'watch_later';
          break;
      }
      const priceGross = school.price;
      const priceNet = school.priceNet;
      let startDate;
      let startTime;
      if (school.startDateTime) {
        startDate = school.startDateTime.substr(0, 10);
        startTime = school.startDateTime.substr(11, 5);
      }

      return {
        ...school,
        area,
        participants,
        availableParticipants,
        meetingPoints,
        startDate,
        startTime,
        isLessonTypePrivate: school.productsSkiSchoolLessonTypeId === lessonTypeEnums.PRIVATE,
        statusName: school.status === statusEnums.INITIATED ? 'Not paid' : school.status,
        statusColor,
        statusIcon,
        priceGross: numberMixin.filters.roundNumber(priceGross),
        priceNet: numberMixin.filters.roundNumber(priceNet),
        weekDayName: getters.allWeekDays()
          .filter(weekDay => weekDay.id === school.weekDay)
          .map(weekDay => weekDay.name)
          .shift(),
        // TODO: SKI-1233 Find person category ages and check booking participant age is valid
        ageMismatch: false,
      };
    });

    return schools.filter(school => school.areaId === selectedAreaId || !selectedAreaId)
      .sort((a, b) => a.productsSkiSchoolLessonTypeId - b.productsSkiSchoolLessonTypeId);
  },

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*}
   */
  getBookingParticipantsWhereSchoolsExist(state, getters, rootState, rootGetters) {
    const stateSchools = state.schools.items;
    const stateParticipants = rootGetters['booking/getParticipantsWithFullName'];
    if (!stateParticipants
      || !stateParticipants.length
      || !stateSchools
      || !Object.keys(stateSchools).length
    ) {
      return [];
    }
    const allBookingParticipantIds = stateSchools.map(
      stateSchool => stateSchool.bookingParticipantId,
    );
    const uniqueBookingParticipantIds = [...new Set(allBookingParticipantIds)];
    const availableParticipants = stateParticipants.filter(
      stateParticipant => uniqueBookingParticipantIds.includes(stateParticipant.id),
    );
    const selectAllItem = { fullName: 'Select all', id: null };

    return [selectAllItem, ...availableParticipants];
  },

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*[]}
   */
  getBookingStayAreasWithAllOption(state, getters, rootState, rootGetters) {
    const stateBookingStayAreas = rootGetters['booking/getBookingStayAreas'];
    if (!stateBookingStayAreas || !stateBookingStayAreas.length) {
      return [];
    }
    const selectAllItem = { name: 'Select all', id: null };

    return [selectAllItem, ...stateBookingStayAreas];
  },

  /**
   * @param state
   * @param getters
   * @returns {undefined|*}
   */
  getAvailableSkiSchoolProductUsedForChangeProduct(state, getters) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return undefined;
    }
    let foundAvailableSchoolProduct;
    const availableSchoolProducts = getters.filterAvailableSchoolProductsByAllFilters(state);
    for (let i = 0; i < availableSchoolProducts.length; i += 1) {
      let availableSchoolProduct = availableSchoolProducts[i];
      availableSchoolProduct = {
        ...availableSchoolProduct,
        priceGross: numberMixin.filters.roundNumber(availableSchoolProduct.priceGross, 0),
        priceNet: numberMixin.filters.roundNumber(availableSchoolProduct.priceNet, 0),
      };
      foundAvailableSchoolProduct = availableSchoolProduct;
      break;
    }

    return foundAvailableSchoolProduct;
  },

  /**
   * @param state
   * @param getters
   * @returns {this|Array}
   */
  getAvailableSkiSchoolProducts(state, getters) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const currentBookingSchoolProducts
      = getters.getBookingSchoolProductsBySelectedBookingParticipant(state);
    const availableSchoolProducts = getters.filterAvailableSchoolProducts(state);
    const defaultPersonCategories = getters.uniquePersonCategoriesFromAvailableSkiSchoolProducts(
      state,
      getters,
    );
    const productsGrouped = {};
    availableSchoolProducts.forEach((availableSchoolProduct) => {
      const levelId = availableSchoolProduct.level.id;
      const lessonTypeId = availableSchoolProduct.lessonType.id;
      const skiTypeId = availableSchoolProduct.skiType.id;
      const personCategoryId = availableSchoolProduct.personCategory.id;
      const prices = {};
      defaultPersonCategories.forEach((defaultPersonCategory) => {
        const defaultPersonCategoryId = defaultPersonCategory.id;
        if (prices[defaultPersonCategoryId] === undefined) {
          prices[defaultPersonCategoryId] = {};
        }
        let foundAvailableSchoolPrice;
        let bookingSchoolProductId;
        let foundPriceId;
        let foundPersonCategory;
        if (defaultPersonCategory.id === personCategoryId) {
          foundAvailableSchoolPrice = availableSchoolProduct;
          foundPriceId = foundAvailableSchoolPrice.id;
          foundPersonCategory = foundAvailableSchoolPrice.personCategory;
          const foundBookingSchoolProduct = currentBookingSchoolProducts.find(
            bookingSchoolProduct =>
              bookingSchoolProduct.seasonId === availableSchoolProduct.season.id
              && bookingSchoolProduct.personCategoryId === personCategoryId
              && bookingSchoolProduct.lessonTypeId === availableSchoolProduct.lessonType.id
              && bookingSchoolProduct.skiTypeId === availableSchoolProduct.skiType.id
              && bookingSchoolProduct.levelId === availableSchoolProduct.level.id
              && bookingSchoolProduct.days === availableSchoolProduct.days
              && bookingSchoolProduct.minutes === availableSchoolProduct.durationMinutes
              && bookingSchoolProduct.weekDay === availableSchoolProduct.weekDay
              && bookingSchoolProduct.maxNumberOfPersons === availableSchoolProduct.numberOfPersons,
          );
          if (foundBookingSchoolProduct) {
            bookingSchoolProductId = foundBookingSchoolProduct.id;
          }
        }
        prices[defaultPersonCategoryId] = {
          bookingSchoolProductId,
          priceGross: numberMixin.filters.roundNumber(availableSchoolProduct.priceGross, 0),
          priceNet: numberMixin.filters.roundNumber(availableSchoolProduct.priceNet, 0),
          id: foundPriceId,
          personCategory: foundPersonCategory,
          levelId,
        };
      });
      const level = {
        ...availableSchoolProduct.level,
        prices,
      };
      const skiLessonKey = `${skiTypeId}-${lessonTypeId}`;
      const numberOfPersons = availableSchoolProduct.numberOfPersons;
      const days = availableSchoolProduct.days;
      const durationMinutes = availableSchoolProduct.durationMinutes;
      const personDayDurationKey = `${numberOfPersons}-${days}-${durationMinutes}`;
      let levels = {};
      if (!productsGrouped[skiLessonKey]) {
        productsGrouped[skiLessonKey] = {};
      } else if (!productsGrouped[skiLessonKey][personDayDurationKey]) {
        productsGrouped[skiLessonKey][personDayDurationKey] = {};
      } else if (productsGrouped[skiLessonKey][personDayDurationKey].levels[levelId] !== undefined) {
        const mergedPrices = {};
        const foundLevel = productsGrouped[skiLessonKey][personDayDurationKey].levels[levelId];
        Object.entries(foundLevel.prices).forEach(([existingPersonCategoryKey, price]) => {
          if (price.id === undefined) {
            const newPrice = prices[personCategoryId];
            if (newPrice) {
              mergedPrices[personCategoryId] = newPrice;
            }
          } else {
            mergedPrices[existingPersonCategoryKey] = price;
          }
        });
        level.prices = mergedPrices;
      } else {
        levels = productsGrouped[skiLessonKey][personDayDurationKey].levels;
      }
      levels[levelId] = level;
      productsGrouped[skiLessonKey][personDayDurationKey] = {
        product: availableSchoolProduct,
        skiType: availableSchoolProduct.skiType,
        lessonType: availableSchoolProduct.lessonType,
        weekDayName: getters.allWeekDays()
          .filter(weekDay => weekDay.id === availableSchoolProduct.weekDay)
          .map(weekDay => weekDay.name)
          .shift(),
        levels,
      };
    });

    return productsGrouped;
  },

  /**
   * @param state
   * @returns {{totalGross: *, totalNet: *}}
   */
  getSkiSchoolTotalPrice(state) {
    const stateSchools = state.schools.items;
    let totalGross = 0;
    let totalNet = 0;
    Object.values(stateSchools).forEach((stateSchool) => {
      totalGross += stateSchool.price;
      totalNet += stateSchool.priceNet;
    });

    return {
      totalGross: numberMixin.filters.roundNumber(totalGross),
      totalNet: numberMixin.filters.roundNumber(totalNet),
    };
  },

  /**
   * @param state
   * @returns {number}
   */
  getTotalNumberOfSkiSchoolProducts(state) {
    return state.schools.items.length;
  },

  /**
   * @param state
   * @param getters
   * @returns {this|Array}
   */
  getAvailableSkiSchoolProductsPersonCategoryHeaders(state, getters) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }

    return getters.uniquePersonCategoriesFromAvailableSkiSchoolProducts(state, getters);
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableNumberOfDays(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const days = [];
    stateAvailableSchoolProducts.forEach((stateAvailableSchoolProduct) => {
      days.push(stateAvailableSchoolProduct.days);
    });

    return [...new Set(days)];
  },

  /**
   * @param state
   * @param getters
   * @returns {Array|*[]}
   */
  getAvailableWeekDays(state, getters) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const weekDays = [];
    stateAvailableSchoolProducts.forEach((stateAvailableSchoolProduct) => {
      weekDays.push(stateAvailableSchoolProduct.weekDay);
    });
    const uniqueWeekDays = [...new Set(weekDays)];

    return getters.allWeekDays().filter(
      weekDay => uniqueWeekDays.includes(weekDay.id),
    );
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableLessonDurations(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const durations = [];
    stateAvailableSchoolProducts.forEach((stateAvailableSchoolProduct) => {
      durations.push(stateAvailableSchoolProduct.durationMinutes);
    });

    return [...new Set(durations)];
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableSkiTypes(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const skiTypes = [];
    stateAvailableSchoolProducts.forEach((stateAvailableSchoolProduct) => {
      skiTypes.push(stateAvailableSchoolProduct.skiType);
    });

    return [...new Set(skiTypes)];
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableLessonTypes(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const lessonTypes = [];
    stateAvailableSchoolProducts.forEach((stateAvailableSchoolProduct) => {
      lessonTypes.push(stateAvailableSchoolProduct.lessonType);
    });

    return [...new Set(lessonTypes)];
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableNumberOfPersons(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const numberOfPersons = [];
    stateAvailableSchoolProducts.forEach((stateAvailableSchoolProduct) => {
      numberOfPersons.push(stateAvailableSchoolProduct.numberOfPersons);
    });

    return [...new Set(numberOfPersons)];
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableLessonTypesUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const availableLessonTypes = stateAvailableSchoolProducts.map(
      product => product.lessonType,
    );

    return [...new Set(availableLessonTypes)];
  },

  /**
   * @param state
   * @returns {any[]|Array}
   */
  getAvailableNumberOfDaysUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const availableDays = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId,
    ).map(
      product => product.days,
    );

    return [...new Set(availableDays)];
  },

  /**
   * @param state
   * @returns {any[]|Array}
   */
  getAvailableNumberOfPersonsUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const availableNumberOfPersons = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId
        && product.days === selectedNumberOfDays,
    ).map(
      product => product.numberOfPersons,
    );

    return [...new Set(availableNumberOfPersons)];
  },

  /**
   * @param state
   * @returns {any[]|Array}
   */
  getAvailablePersonCategoriesUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedNumberOfPersons = state.changeProduct.selectedNumberOfPersons;
    const availablePersonCategories = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId
        && product.days === selectedNumberOfDays
        && product.numberOfPersons === selectedNumberOfPersons,
    ).map(
      product => product.personCategory,
    );

    return [...new Set(availablePersonCategories)];
  },

  /**
   * @param state
   * @param getters
   * @returns {Array|*}
   */
  getAvailableWeekDaysUsedForChangeProduct(state, getters) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedNumberOfPersons = state.changeProduct.selectedNumberOfPersons;
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const availableWeekDays = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId
      && product.days === selectedNumberOfDays
      && product.numberOfPersons === selectedNumberOfPersons
      && product.personCategory.id === selectedPersonCategoryId,
    ).map(
      product => product.weekDay,
    );
    const uniqueWeekDays = [...new Set(availableWeekDays)];
    const allWeekDays = getters.allWeekDays();

    return allWeekDays.filter(weekDay =>
      uniqueWeekDays.includes(weekDay.id),
    );
  },

  /**
   * @param state
   * @returns {any[]|Array}
   */
  getAvailableLessonDurationsUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedNumberOfPersons = state.changeProduct.selectedNumberOfPersons;
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedWeekDayNumber = state.changeProduct.selectedWeekDayNumber;
    const availableDurationMinutes = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId
        && product.days === selectedNumberOfDays
        && product.numberOfPersons === selectedNumberOfPersons
        && product.personCategory.id === selectedPersonCategoryId
        && product.weekDay === selectedWeekDayNumber,
    ).map(
      product => product.durationMinutes,
    );

    return [...new Set(availableDurationMinutes)];
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableSkiTypesUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedNumberOfPersons = state.changeProduct.selectedNumberOfPersons;
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedWeekDayNumber = state.changeProduct.selectedWeekDayNumber;
    const selectedLessonDuration = state.changeProduct.selectedLessonDuration;
    const availableSkiTypeIds = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId
        && product.days === selectedNumberOfDays
        && product.numberOfPersons === selectedNumberOfPersons
        && product.personCategory.id === selectedPersonCategoryId
        && product.weekDay === selectedWeekDayNumber
        && product.durationMinutes === selectedLessonDuration,
    ).map(
      product => product.skiType,
    );

    return [...new Set(availableSkiTypeIds)];
  },

  /**
   * @param state
   * @returns {Array|*[]}
   */
  getAvailableLevelTypesUsedForChangeProduct(state) {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedNumberOfPersons = state.changeProduct.selectedNumberOfPersons;
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedWeekDayNumber = state.changeProduct.selectedWeekDayNumber;
    const selectedLessonDuration = state.changeProduct.selectedLessonDuration;
    const selectedSkiTypeId = state.changeProduct.selectedSkiTypeId;
    const availableLevelTypes = stateAvailableSchoolProducts.filter(
      product => product.lessonType.id === selectedLessonTypeId
        && product.days === selectedNumberOfDays
        && product.numberOfPersons === selectedNumberOfPersons
        && product.personCategory.id === selectedPersonCategoryId
        && product.weekDay === selectedWeekDayNumber
        && product.durationMinutes === selectedLessonDuration
        && product.skiType.id === selectedSkiTypeId,
    ).map(
      product => product.level,
    );

    return [...new Set(availableLevelTypes)];
  },

  /**
   * @returns {function(): *[]}
   */
  allWeekDays: () => () => [
    { id: 1, name: 'Monday' },
    { id: 2, name: 'Tuesday' },
    { id: 3, name: 'Wednesday' },
    { id: 4, name: 'Thursday' },
    { id: 5, name: 'Friday' },
    { id: 6, name: 'Saturday' },
    { id: 0, name: 'Sunday' },
  ],

  /**
   * @returns {Function}
   */
  getBookingSchoolProductsBySelectedBookingParticipant: () => (state) => {
    const selectedBookingParticipantId = state.search.selectedBookingParticipantId;
    const stateSchoolPrices = state.schools.items;
    if (!selectedBookingParticipantId || !stateSchoolPrices.length) {
      return [];
    }
    const schoolPrices = stateSchoolPrices.filter(schoolPrice =>
      schoolPrice.skiSchoolParticipants.some(
        participant => participant.bookingParticipantId === selectedBookingParticipantId,
      ),
    );
    if (!schoolPrices) {
      return [];
    }

    return map(schoolPrices, school => ({
      id: school.id,
      seasonId: school.productsSkiSchoolSeasonId,
      personCategoryId: school.productsSkiSchoolSeasonPersonCategoryId,
      lessonTypeId: school.productsSkiSchoolLessonTypeId,
      skiTypeId: school.productsSkiSchoolSkiTypeId,
      levelId: school.productsSkiSchoolSeasonLevelId,
      days: school.numberOfDays,
      minutes: school.minutes,
      weekDay: school.weekDay,
      maxNumberOfPersons: school.maxNumberOfPersons,
      startDateTime: school.startDateTime,
    }));
  },

  /**
   * @returns {Function}
   */
  uniquePersonCategoriesFromAvailableSkiSchoolProducts: () => (state, getters) => {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const availableSchoolProducts = getters.filterAvailableSchoolProducts(state);
    const uniquePersonCategories = [];
    availableSchoolProducts.forEach((availableSchoolProduct) => {
      if (!uniquePersonCategories.some(personCategoryHeader =>
        personCategoryHeader.id === availableSchoolProduct.personCategory.id,
      )) {
        uniquePersonCategories.push(availableSchoolProduct.personCategory);
      }
    });

    return uniquePersonCategories;
  },

  /**
   * @returns {Function}
   */
  filterAvailableSchoolProducts: () => (state) => {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedLessonTypeId = state.search.selectedLessonTypeId;
    const selectedWeekDayNumber = state.search.selectedWeekDayNumber;
    const selectedNumberOfDays = state.search.selectedNumberOfDays;
    const selectedLessonDuration = state.search.selectedLessonDuration;
    const selectedSkiTypeIds = state.search.selectedSkiTypes;
    const selectedLevelId = state.search.selectedLevelId;
    const selectedNumberOfPersons = state.search.selectedNumberOfPersons;

    return stateAvailableSchoolProducts.filter(availableSchoolProduct => (
      (!selectedLessonTypeId || availableSchoolProduct.lessonType.id === selectedLessonTypeId)
      && (selectedWeekDayNumber === undefined || selectedWeekDayNumber === availableSchoolProduct.weekDay)
      && (!selectedNumberOfDays || availableSchoolProduct.days === selectedNumberOfDays)
      && (!selectedLessonDuration
        || availableSchoolProduct.durationMinutes === selectedLessonDuration
      )
      && (!selectedSkiTypeIds.length
        || selectedSkiTypeIds.includes(availableSchoolProduct.skiType.id)
      )
      && (!selectedNumberOfPersons
        || availableSchoolProduct.numberOfPersons === selectedNumberOfPersons
      )
      && (!selectedLevelId || availableSchoolProduct.level.id === selectedLevelId)
    ));
  },

  /**
   * @returns {Function}
   */
  filterAvailableSchoolProductsByAllFilters: () => (state) => {
    const stateAvailableSchoolProducts = state.availableSchoolProducts.items;
    if (!stateAvailableSchoolProducts || !stateAvailableSchoolProducts.length) {
      return [];
    }
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;
    const selectedLessonTypeId = state.changeProduct.selectedLessonTypeId;
    const selectedWeekDayNumber = state.changeProduct.selectedWeekDayNumber;
    const selectedLessonDuration = state.changeProduct.selectedLessonDuration;
    const selectedLevelId = state.changeProduct.selectedLevelId;
    const selectedSkiTypeId = state.changeProduct.selectedSkiTypeId;
    const selectedNumberOfPersons = state.changeProduct.selectedNumberOfPersons;

    return stateAvailableSchoolProducts.filter(availableSchoolProduct => (
      selectedPersonCategoryId === availableSchoolProduct.personCategory.id
      && selectedNumberOfDays === availableSchoolProduct.days
      && selectedLessonTypeId === availableSchoolProduct.lessonType.id
      && selectedWeekDayNumber === availableSchoolProduct.weekDay
      && selectedLessonDuration === availableSchoolProduct.durationMinutes
      && selectedLevelId === availableSchoolProduct.level.id
      && selectedSkiTypeId === availableSchoolProduct.skiType.id
      && selectedNumberOfPersons === availableSchoolProduct.numberOfPersons
    ));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/school/getters.js